module.exports = __webpack_public_path__ + "img/自定义头像.d6dba0e8.png";